import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import App from './App.vue'
import router from './router'
import './assets/style.css' 
import { globalStore } from './stores/globalStore'
const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

//load search params from local storage
const store = globalStore();
store.loadSearchParamsFromLocalStorage(); 

app.use(router)
app.mount('#app')
